export default __webpack_public_path__ + "static/media/pvp_pve_icon.c72820f1.svg";